import { render, staticRenderFns } from "./EmplyLayout.vue?vue&type=template&id=2aede085"
import script from "./EmplyLayout.vue?vue&type=script&lang=js"
export * from "./EmplyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports